<template>
  <a-tooltip
    v-if="text"
    overlay-class-name="td-tooltip contact-tooltip"
  >
    <template slot="title">
      <p class="name fs-bold">
        {{ contactName }}
      </p>
      <div class="mobiles">
        <label>{{ $t('message["233"]') }}</label>
        <p
          v-for="(item, i) in contactMobile"
          :key="i"
        >
          {{ item }}
        </p>
        <p v-if="!contactMobile || !contactMobile.length">
          {{ $t('message["1543"]') }}
        </p>
      </div>
      <div
        v-if="text.contact_email"
        class="emails"
      >
        <label>{{ $t('message["1505"]') }}</label>
        <p
          v-for="(item, i) in contactEmail"
          :key="i"
        >
          {{ item }}
        </p>
        <p v-if="!contactEmail || !contactEmail.length">
          {{ $t('message["1543"]') }}
        </p>
      </div>
    </template>
    <div class="contact-content textOverflow">
      {{ contactName || '- -' }}
    </div>
  </a-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    contactName () {
      const { contact_name: contactName = {} } = this.text
      return contactName.fieldvalue || ''
    },
    contactEmail () {
      const { contact_email: contactEmail = {} } = this.text
      return contactEmail.fieldvalue || []
    },
    contactMobile () {
      const { contact_mobile: contactMobile = {} } = this.text
      return contactMobile.fieldvalue || []
    }
  }
}
</script>

<style lang="scss" scoped>
// .contact-content {
  // width: 126px;
// }
</style>
